import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/list-bullet.vue
var o = {
	name: "DtIconListBullet",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--list-bullet"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "List Bullet",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M1.704 4.865a1.245 1.245 0 0 1 1.092 0 1.25 1.25 0 1 1-1.092 0ZM4.5 2.682a.5.5 0 0 0 .5.5h5.5a.5.5 0 1 0 0-1H5a.5.5 0 0 0-.5.5ZM1.704 3.806a1.25 1.25 0 1 1 1.093-2.249 1.25 1.25 0 0 1-1.093 2.25ZM4.5 9.318a.5.5 0 0 1 .5-.5h5.5a.5.5 0 1 1 0 1H5a.5.5 0 0 1-.5-.5ZM1.734 8.18a1.25 1.25 0 1 0 1.033 2.277A1.25 1.25 0 0 0 1.734 8.18ZM4.5 5.99a.5.5 0 0 0 .5.5h5.5a.5.5 0 1 0 0-1H5a.5.5 0 0 0-.5.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=list-bullet.js.map